// src/pages/Question/BotPrompt.jsx
import React from 'react';

const BotPrompt = ({
  defaultAvatarUrl,
  time,
  message,
  options,
  onOptionSelect,
}) => (
  <div className='media my-4 justify-content-start align-items-start'>
    {/* Avatar */}
    <div className='image-box me-sm-4 me-2'>
      <img
        src={defaultAvatarUrl}
        alt='Bot Avatar'
        className='rounded-circle img-1'
        style={{ width: 48, height: 48, objectFit: 'cover' }}
      />
      <span className='active1' />
    </div>

    {/* Bubble */}
    <div className='message-received'>
      <p className='mb-1'>{message}</p>

      {options && (
        <div className='mt-2'>
          {options.map((option, index) => (
            <div key={index} className='form-check mb-2'>
              <input
                className='form-check-input'
                type='radio'
                name='botOptions'
                id={`bot-${option.value}`}
                value={option.value}
                onClick={() => onOptionSelect(option.value)}
              />
              <label
                className='form-check-label'
                htmlFor={`bot-${option.value}`}
              >
                {option.label}
              </label>
            </div>
          ))}
        </div>
      )}

      <span className='fs-12'>{time}</span>
    </div>
  </div>
);

export default BotPrompt;
